import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsBlock78({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id={"78"}><path vectorEffect="non-scaling-stroke" id="Vector" d="M17.5628 4.78576C17.5628 4.23338 17.3468 3.75719 16.9148 3.35719C16.5136 2.98576 16.0148 2.80005 15.4182 2.80005H14.6159C14.0193 2.80005 13.5205 2.98576 13.1193 3.35719C12.6873 3.75719 12.4713 4.23338 12.4713 4.78576H10.3113C10.3113 4.09053 10.5119 3.42862 10.913 2.80005C11.3348 2.17148 11.8645 1.681 12.5022 1.32862C13.1708 0.976239 13.8753 0.800049 14.6159 0.800049H15.4182C16.1588 0.800049 16.8633 0.976239 17.5319 1.32862C18.1696 1.681 18.6993 2.17148 19.121 2.80005C19.5222 3.42862 19.7228 4.09053 19.7228 4.78576H17.5628ZM12.4559 6.80005C12.4559 7.35243 12.6719 7.82862 13.1039 8.22862C13.5153 8.60957 14.0193 8.80005 14.6159 8.80005H15.4182C16.0148 8.80005 16.5136 8.61433 16.9148 8.24291C17.3468 7.84291 17.5628 7.36672 17.5628 6.81433H19.7228C19.7228 7.50957 19.5222 8.17148 19.121 8.80005C18.6993 9.42862 18.1696 9.9191 17.5319 10.2715C16.8633 10.6239 16.1588 10.8 15.4182 10.8H14.6159C13.8856 10.8 13.1759 10.6191 12.4868 10.2572C11.849 9.90481 11.3193 9.41433 10.8976 8.78576C10.4965 8.15719 10.2959 7.49529 10.2959 6.80005H12.4559ZM17.5628 6.80005V4.78576H12.4559V6.80005H17.5628Z" fill="currentColor" /><path vectorEffect="non-scaling-stroke" id="Vector_2" d="M0.2771 2.78576L2.4371 0.800049V4.80005H0.2771V2.78576ZM2.4371 0.800049V2.81433H2.46796H7.52853V0.800049L9.68853 2.80005V3.24291L5.09081 9.42862H3.10053L3.0851 8.78576H5.2451V10.8H3.0851V8.78576L7.52853 2.80005V0.800049H2.46796H2.4371ZM2.4371 0.800049V2.78576V0.800049Z" fill="currentColor" /></g></Svg>;
}
export default OrdinalsBlock78;